var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2426 4.75738C17.5858 7.10053 17.5858 10.8995 15.2426 13.2427M6.75736 13.2426C4.41421 10.8995 4.41421 7.10049 6.75736 4.75735M3.92893 16.0711C0.0236893 12.1658 0.0236893 5.8342 3.92893 1.92896M18.0711 1.929C21.9763 5.83424 21.9763 12.1659 18.0711 16.0711M13 9.00002C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9.00002C9 7.89545 9.89543 7.00002 11 7.00002C12.1046 7.00002 13 7.89545 13 9.00002Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.8ba2dde51b3ef4824321c0d3ef96369a.svg";
export { ForwardRef as ReactComponent };